const moment = require("moment");
const ActionType = require("../action-types/promocodes");
const Deeply = require("utils/deeply");

const internals = {
    initial: () => ({
        isFetching: false,
        isSaving: false,
        items: null,
        hasFetchedAll: false
    })
};

const convertDates = promo => {
    if (promo.startDate && typeof promo.startDate === "string") {
        promo.startDate = moment(promo.startDate);
    }

    if (promo.endDate && typeof promo.endDate === "string") {
        promo.endDate = moment(promo.endDate);
    }
};

const createOrUpdate = (state, promo) => {
    convertDates(promo);

    let newState = Deeply(state);

    // If there are already promos loaded, try updating the existing promo if it exists,
    // otherwise insert it.
    if (state.items) {
        const index = state.items.findIndex(k => k.id === promo.id);

        if (index != null) {
            newState = newState.set(["items", index], promo);
        } else {
            newState = newState.push("items", promo);
        }
    } else {
        newState = newState.set("items", [promo]);
    }

    return newState;
};

module.exports = (state, action) => {
    const { type, payload } = action;
    state = state || internals.initial();

    switch (type) {
        case ActionType.ADD_PROMOCODE_BEGIN:
            return Deeply(state)
                .set("isSaving", true)
                .value();

        case ActionType.ADD_PROMOCODE_FAILURE:
            return Deeply(state)
                .set("isSaving", false)
                .value();

        case ActionType.ADD_PROMOCODE_SUCCESS:
            return createOrUpdate(state, payload.promo)
                .set("isSaving", false)
                .value();

        case ActionType.FETCH_PROMOCODES_BEGIN:
            return Deeply(state)
                .set("isFetching", true)
                .value();

        case ActionType.FETCH_PROMOCODES_FAILURE:
            return Deeply(state)
                .set("isFetching", false)
                .value();

        case ActionType.FETCH_PROMOCODES_SUCCESS:
            payload.items.forEach(convertDates);

            return Deeply(state)
                .set("isFetching", false)
                .set("items", payload.items)
                .set("hasFetchedAll", true)
                .value();

        case ActionType.FETCH_SINGLE_PROMOCODE_BEGIN:
            return Deeply(state)
                .set("isFetching", true)
                .value();

        case ActionType.FETCH_SINGLE_PROMOCODE_FAILURE:
            return Deeply(state)
                .set("isFetching", false)
                .value();

        case ActionType.FETCH_SINGLE_PROMOCODE_SUCCESS:
            convertDates(payload.promo);

            return createOrUpdate(state, payload.promo)
                .set("isFetching", false)
                .value();

        case ActionType.UPDATE_PROMOCODE_BEGIN:
            return Deeply(state)
                .set("isSaving", true)
                .value();

        case ActionType.UPDATE_PROMOCODE_FAILURE:
            return Deeply(state)
                .set("isSaving", false)
                .value();

        case ActionType.UPDATE_PROMOCODE_SUCCESS:
            return createOrUpdate(state, payload.promo)
                .set("isSaving", false)
                .value();
    }

    return state;
};



// WEBPACK FOOTER //
// ./src/reducers/promocodes.js